function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import _ from 'underscore';
import Poll from './poll';
import SegmentingOptions from './segmenting_options';
import MCPOptions from './multiple_choice_poll_options';

var MultipleChoicePoll = /*#__PURE__*/function (_Poll) {
  _inheritsLoose(MultipleChoicePoll, _Poll);

  function MultipleChoicePoll() {
    return _Poll.apply(this, arguments) || this;
  }

  var _proto = MultipleChoicePoll.prototype;

  _proto.initialize = function initialize(options) {
    _Poll.prototype.initialize.apply(this, arguments);

    var comparisonReport = this.get('comparison_report') || {};
    this.segmentingOptions = new SegmentingOptions(comparisonReport.groups);
    this.segmentingOptions.poll = this;
    this.mcpOptions = new MCPOptions(this.attributes.options, {
      silent: true
    });
    this.mcpOptions.poll = this;
    this.listenTo(this.mcpOptions, 'add', this.onAddOption);
    this.listenTo(this.mcpOptions, 'remove', this.onRemoveOption);
    this.listenTo(this, 'change:options', this.updateOptions);
  };

  _proto.summaryTableUrl = function summaryTableUrl() {
    return this._urlBase().segment('table').toString();
  }
  /*
   * Don't call this 'validate' as it will be used as validation for
   * all MCPs
   */
  ;

  _proto.validateOptions = function validateOptions() {
    /*
     * Don't short circuit .isValid() so we can get error status
     * of all the mcpOptions
     */
    if (_.every(this.mcpOptions.invoke('isValid'))) {} else {
      return _.unique(_.compact(this.mcpOptions.map(function (m) {
        return m.validationError;
      })));
    }
  };

  _proto.hasImageOption = function hasImageOption() {
    return this.mcpOptions.hasImage();
  };

  _proto.hasLatexOption = function hasLatexOption() {
    return this.mcpOptions.hasLatex();
  };

  _proto.hasAlphaNumericKeyword = function hasAlphaNumericKeyword() {
    return this.mcpOptions.hasAlphaNumericKeyword();
  };

  _proto.highestResponse = function highestResponse() {
    return this.mcpOptions && this.mcpOptions.length ? this.mcpOptions.highestResult() : null;
  };

  _proto.onAddOption = function onAddOption(option) {
    this.trigger('options:add', option);
  };

  _proto.onRemoveOption = function onRemoveOption(option) {
    this.trigger('options:remove', option);
  };

  _proto.isGraded = function isGraded() {
    return this.mcpOptions.hasCorrect();
  };

  _proto.updateOptions = function updateOptions() {
    this.mcpOptions.set(this.get('options'));
  }
  /**
   * Generate a rootless JSON object of all model attrs.
   * @param {Object} options
   * @return {Object}
   */
  ;

  _proto.toJSON = function toJSON(options) {
    if (options === void 0) {
      options = {};
    } // Grab the generated JSON from the super class


    var json = _Poll.prototype.toJSON.call(this, options);

    if (this.has('grading_enabled')) {
      json.grading_enabled = this.get('grading_enabled');
    }

    if (this.has('flash_options')) {
      json.flash_options = this.get('flash_options');
    }

    json.options = this.mcpOptions.invoke('toJSON'); // don't include keywords if simple keywords is enabled and not using custom
    // session keyword format because these are generated from the server

    if (this.isSimpleKeywords() && !this.isCustomSessionKeywordFormat()) {
      for (var _iterator = _createForOfIteratorHelperLoose(json.options), _step; !(_step = _iterator()).done;) {
        var option = _step.value;
        delete option.keyword;
      }
    }

    return json;
  };

  _proto.isCustomSessionKeywordFormat = function isCustomSessionKeywordFormat() {
    var sessionKeywordFormat = this.get('session_keyword_format') || '';
    return sessionKeywordFormat.toLowerCase() === 'custom';
  };

  _proto.parse = function parse(json, options) {
    if (json === void 0) {
      json = {};
    }

    if (options === void 0) {
      options = {};
    }

    json = _Poll.prototype.parse.apply(this, arguments);
    options = _.defaults({}, options, {
      resetKeyword: false,
      resetOptions: true
    });

    if (json.options && this.mcpOptions) {
      if (options.resetKeyword) {
        this.mcpOptions.resetKeywords(json.options);
      }

      if (options.resetOptions) {
        // Don't need to go through validation logic here
        options.validate = false;
        this.mcpOptions.set(json.options, options);
      } else {
        delete json.options;
      }
    }
    /*
     * do this check here because #set uses _.isEqual to determine
     * if this object has changed. _.isEqual only does a shallow comparison
     * so it doesn't detect changes properly
     */


    if (json.comparison_report) {
      if (this.segmentingOptions) {
        this.segmentingOptions.set(json.comparison_report.groups, options);
      }
    }

    return json;
  }
  /**
   * Parse Firehose response into the model.
   * @param {object} data Firehose response data.
   * @return {object} Returns potentially mutated data.
   */
  ;

  _proto.processLiveResponse = function processLiveResponse(data) {
    if (data === void 0) {
      data = {};
    }

    data = _Poll.prototype.processLiveResponse.call(this, data);
    this.flashOptions().processLiveResponse(data);
    return data;
  };

  _proto.toggle = function toggle(attr, opts, value) {
    if (opts === void 0) {
      opts = {};
    }

    if (this.currentArchive) {
      // When archived options are loaded into this model, we need to prevent
      // the `options` collection from being replaced by fresh option data
      // coming back from the `save` response.
      opts = Object.assign({}, opts, {
        resetOptions: false
      });
    }

    return _Poll.prototype.toggle.call(this, attr, opts, value);
  };

  _proto.toggleGradingEnabled = function toggleGradingEnabled(val) {
    if (!val) {
      this.mcpOptions.each(function (opt) {
        return opt.set({
          correct_response: false,
          correct: false
        });
      });
    }

    return this.save({
      grading_enabled: val
    });
  };

  _proto.hasCustomGlobalKeyword = function hasCustomGlobalKeyword() {
    return !this.get('simple_keywords') && !this.mcpOptions.all(function (option) {
      return option.isAutoKeyword();
    });
  };

  _createClass(MultipleChoicePoll, [{
    key: "defaultType",
    get: function get() {
      return 'multiple_choice_poll';
    }
  }, {
    key: "modelProperties",
    get: function get() {
      return _Poll.prototype.modelProperties.concat(['session_keyword_format', 'instruction_image_url', 'instruction_image_alt', 'responses_per_option']);
    }
    /**
     * Returns the collection for comparison reports. Consumers can access this
     * collection to fetch a list of or individual comparison data.
     * @return {Backbone.Collection.Comparisons}
     */

  }, {
    key: "comparisons",
    get: function get() {
      return this.instance.comparisons;
    }
  }]);

  return MultipleChoicePoll;
}(Poll);

export { MultipleChoicePoll as default };